import api from "../../../api/axios";

/**
 * CHAT-ENTITY-SHARE-QA-R2 — server-authoritative shareable candidates.
 *
 * GET /api/chat/<chatId>/entity-share-candidates/
 *   ?type=client|property&search=&limit=&offset=
 *
 * Response:
 *   {
 *     entity_type: "client" | "property",
 *     results: [{ type, id, label, secondary, thumbnail }],
 *     count, limit, offset
 *   }
 */
export const fetchEntityShareCandidates = (chatId, params = {}, config = {}) =>
  api
    .get(`/chat/${chatId}/entity-share-candidates/`, {
      params,
      signal: config.signal,
    })
    .then((res) => res.data);
